'use client'

import React from 'react'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { normalizeStatus, toStatusLabel, toStatusTone, type UiEstimateStatus } from '../utils/status'

interface StatusPillProps {
  status: string | null | undefined
  className?: string
}

/**
 * 견적서 상태 배지 컴포넌트
 * 상태 라벨은 utils/status.ts의 getStatusLabel만 사용
 * Badge 컴포넌트를 사용하여 shadcn/ui 스타일 적용
 */
export const StatusPill: React.FC<StatusPillProps> = ({ status, className }) => {
  const normalized = normalizeStatus(status)
  
  if (!normalized) {
    return null
  }
  
  const variant = toStatusTone(normalized)
  const label = toStatusLabel(normalized)
  
  return (
    <Badge
      variant={variant}
      className={cn('rounded-full px-2.5 py-0.5 text-xs font-medium', className)}
    >
      {label}
    </Badge>
  )
}

